// Signs the user out when the API rejects their session: an expired token
// (403 "Invalid or expired token") or an account that no longer exists (401).
// The network pages call fetch directly, so this wraps fetch once for all of
// them.
const API_URL = process.env.REACT_APP_API_URL || 'https://api.alooma.mg';

export function installSessionGuard() {
  if (typeof window === 'undefined' || window.__aloomaSessionGuard) return;
  window.__aloomaSessionGuard = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);
    const url = typeof input === 'string' ? input : input && input.url;
    const sentToken = !!localStorage.getItem('token');
    if (sentToken && url && url.startsWith(API_URL) && (response.status === 401 || response.status === 403)) {
      let expired = response.status === 401;
      if (!expired) {
        try {
          const data = await response.clone().json();
          expired = data && data.message === 'Invalid or expired token';
        } catch (_) {
          expired = false;
        }
      }
      // Login failures are 401s too; only end an existing session.
      const isLogin = url.includes('/api/auth/login') || url.includes('/api/auth/register');
      if (expired && !isLogin) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== '/network') window.location.assign('/network');
      }
    }
    return response;
  };
}
